import React from 'react';
import '../template-file-css/document-file-template.css';


export const ACTS_MstPrescreening = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='ACTS_MstPrescreening' className='file-pdf-document'>
            <div className='file-template'>


                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>NAME:</span></td>
                        <td className='w-250'><span className='eleHeader'>MEDICAID NUMBER</span></td>
                        <td className='w-250'><span className='eleHeader'>DATE:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtName" name="txtName" className='add-only' /> </td>
                        <td className='w-250'>
                            <input type="text" id="txtMedicaidNumber" name="txtMedicaidNumber" className='add-only' /> </td>
                        <td className='w-250'>
                            <input type="text" id="txtDate" name="txtDate" className='add-only' /> </td>
                    </tr>
                </table>


                <p className='w-750'>
                    <span className='eleHeader'>Entrance Criteria:</span>
                    The recipient is eligible for this service when:
                </p>

                <ol type="A">
                    <li>There is an Axis I or II diagnosis present, other than a sole diagnosis of Developmental
                        Disability
                        <br />
                        <strong>AND</strong>
                    </li>
                    <li>The youth should be between the ages of 7 through 17.
                        <br />
                        <strong>AND</strong>
                    </li>
                    <li>The youth displays willful behavioral misconduct (e.g., theft, property destruction, assault,
                        communicating verbal threats, other status offense, truancy or substance use/abuse or
                        juvenile sex offense).
                        <br />
                        <strong>AND</strong>
                    </li>
                    <li>The youth is at imminent risk of out-of-home placement or is currently in out-of-home
                        placement due to delinquency and reunification is imminent within 30 days of referral.
                        <br />
                        <strong>AND</strong>
                    </li>
                    <li>The youth has a caregiver that is willing to assume long term parenting role and caregiver
                        who is willing to participate with service providers for the duration of the treatment.
                    </li>
                </ol>
                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp;</td>
                        <td className='signature w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Signature:</td>
                        <td className='small  w-250'>Date:</td>
                    </tr>
                </table>





            </div>
        </form>

    )
}  
